import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { CirclePlus, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";
import { IItemHistoricoPlano } from "../../../../types";

const detectaPlanoCriado = (acao: string): boolean => {
  const acaoLower = acao.toLowerCase().trim();
  return acaoLower === 'plano criado' || acaoLower.includes('plano criado');
};

const getIconPlanoCriado = (acao: string): { Icon: LucideIcon; color: string } => {
  return { Icon: CirclePlus, color: 'var(--c2e86de)' };
};

export default function CardPlanoCriado({ item, isExpanded, onToggleExpand }: CardHistoricoProps) {
  // Este card é específico para planos, então fazemos type assertion
  const itemPlano = item as IItemHistoricoPlano;
  
  return (
    <CardHistoricoBase
      item={item}
      icon={getIconPlanoCriado(item.acao)}
      temExpansaoDisponivel={true}
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
      expandedContent={<ExpandedContent item={itemPlano} />}
      tituloCustomizado="Plano criado"
    />
  );
}

export const planoCriadoConfig = {
  tipo: 'plano_criado',
  detectaTipo: detectaPlanoCriado,
  getIcon: getIconPlanoCriado,
  temExpansao: () => true,
  Component: CardPlanoCriado
};
